import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import Loader from '@tphglobal/components/loader';
import { ThemeProvider } from '@mui/material/styles';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { Slide, ToastContainer } from 'react-toastify';
import { PersistGate } from 'redux-persist/integration/react';
import theme from '@tphglobal/common/theme';
import { GlobalStyle } from '@tphglobal/common/theme/style.global';
import { history, store, persistor } from './redux/store';
import { fetchBaseData } from './redux/actions';
import 'react-toastify/dist/ReactToastify.css';
import Screen from './screens';
import { PostHogProvider} from 'posthog-js/react'

const options = {
  api_host: window?.config?.REACT_APP_PUBLIC_POSTHOG_HOST,
}

store.dispatch(fetchBaseData());

const App = () => (
  <Provider store={store}>
    <PersistGate loading={<Loader />} persistor={persistor}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <ConnectedRouter history={history}>
          <React.StrictMode>
            <GlobalStyle />
            <ThemeProvider theme={theme}>
              <Screen />
            </ThemeProvider>
            <ToastContainer
              hideProgressBar
              position="top-right"
              closeButton={false}
              autoClose={3000}
              draggable={false}
              transition={Slide}
            />
            <Loader />
          </React.StrictMode>
        </ConnectedRouter>
      </LocalizationProvider>
    </PersistGate>
  </Provider>
);

const root = createRoot(document.getElementById('root'));
root.render( <PostHogProvider 
  apiKey={window?.config?.REACT_APP_PUBLIC_POSTHOG_KEY}
  options={options}
>
  <App />
</PostHogProvider>);
